import { API_URL as api } from "@/config/env";

export const urls = {
   userCountries: `${api}GetUserCountries?`,
   scenarioStatus: `${api}ApprovalScenario/GetScenarioStatus`,
   periods: `${api}ApprovalScenario/GetPeriods`,
   scenariosForApproval: `${api}ApprovalScenario/GetScenarioforApproval`,
   scenarioDetails: `${api}ApprovalScenario/GetScenarioDetails?`,
   approveScenario: `${api}Approval/ApproveScenario`,
   rejectScenario: `${api}Approval/RejectScenario`,
   approveMultile: `${api}Approval/ApproveScenarioMultiple`,
   rejectMultile: `${api}Approval/RejectScenarioMultiple`,
   Upload : `${api}Approve/Upload`,
   Downloadfile: `${api}Define/DownloadFile?`,
};

export function getScenariosForApprovalTable(data) {
   const rows = getScenariosForApprovalRows(data);
   for(let i = 0; i < rows.length; i++) {
      rows[i] = getApproveStatus(rows[i]);
   }
   return { rows };
}

function  getApproveStatus (item){
   let scenarioStatus = item.scenarioStatus.toLowerCase();
  const logedUser = JSON.parse(localStorage.getItem("data"));
   if (logedUser.isAnalyst == true) {
     if (scenarioStatus == "submitted" || scenarioStatus == "locally approved") {
       item['canApproveReject'] = false;
       item['canEdit'] = false;
     }

   }
   else {
     if (scenarioStatus == "approved" || scenarioStatus == "rejected") {
       item['canApproveReject'] = false;
       item['canEdit'] = true;
     }
     else {
       if ((logedUser.isAdmin || (logedUser.isHQUser && logedUser.isApprover))) {
         if (scenarioStatus == "submitted" || scenarioStatus == "locally approved") {
           item['canApproveReject'] = true;
           item['canEdit'] = false;
         }
       }
       else if (!logedUser.isHQUser) {
         item['canApproveReject'] = false;
                    item['canEdit'] = false;
         }
      //  else if (!logedUser.isHQUser) {
      //    if (scenarioStatus == "submitted") {
      //      item['canApproveReject'] = true;
      //      item['canEdit'] = false;
      //    }
      //    else if (scenarioStatus == "locally approved") {
      //      item['canApproveReject'] = false;
      //      item['canEdit'] = false;
      //    }
      //  }
     }
   }
  return item;
 }

function getScenariosForApprovalRows(data) {
   const rows = [];
   data.forEach((item) => {
      rows.push({
         id: item.scenarioID,
         scenarioName: item.scenarioName,
         criticality : item.criticality,
         countryID: item.countryID,
         scenarioStatus: item.scenarioStatus,
         updatedDate: item.updatedDate,
         updatedBy: item.updatedBy,
         isEdit: item.isEdit,
      });
   });
   return rows;
}

export function getProductNames(products) {
   if (products) {
      const names = products.map((product) => {
         return product.product.name;
      });
      return names;
   }
   return [];
}


export function getProductGroupNames(productGroup) {
   if (productGroup) {
      const names = productGroup.map((productGroup) => {
         return productGroup.productGroup.productGroupName;
      });
      return names;
   }
   return [];
}

export function getCustomerGroupNames(customerGroups) {
   if (customerGroups) {
      const names = customerGroups.map((customerGroup) => {
         return customerGroup.customerGroup.customerGroupName;
      });
      return names;
   }
   return [];
}

export function getCustomerNames(customers) {
   if (customers) {
      const names = customers.map((customer) => {
         return customer.customer.customerName;
      });
      return names;
   }
   return [];
}

export function getDSNames(list) {
   if(list) {
      const names = list.map((item) => {
         return item.dataSourceName;
      });
      return names;
   }
   return [];
}
